import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class="header-container single footer-like">
      <div class="logo-container"></div>
      <div class="header-actions">
        <span class="created-by">© 2025 <b>Zenivasoft</b> Tüm hakları saklıdır.</span>
      </div>
    </div>
  `,
})
export class FooterComponent {}
